import { render } from "./SaleTicket.vue?vue&type=template&id=b3ef08ba&scoped=true&ts=true"
import script from "./SaleTicket.vue?vue&type=script&lang=ts"
export * from "./SaleTicket.vue?vue&type=script&lang=ts"

import "./SaleTicket.vue?vue&type=style&index=0&id=b3ef08ba&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b3ef08ba"]])

export default __exports__